/**
 * Wire types of the study-chat practice proposals (TANAI-2616). They mirror the HU1 contract of
 * tangerine-ai: `GET/POST /chat/study/:conversationId/practice-proposals/:proposalId[/attempts]`.
 */

export const PRACTICE_ATTEMPT_STATUS = Object.freeze({
  CREATING: 'CREATING',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  DISCARDED: 'DISCARDED',
  FAILED: 'FAILED',
} as const);

export type PracticeAttemptStatus = (typeof PRACTICE_ATTEMPT_STATUS)[keyof typeof PRACTICE_ATTEMPT_STATUS];

/** `PRACTICE_UNAVAILABLE` cannot be retried; `CREATION_FAILED` can. */
export const PRACTICE_ATTEMPT_ERROR_CODE = Object.freeze({
  PRACTICE_UNAVAILABLE: 'PRACTICE_UNAVAILABLE',
  CREATION_FAILED: 'CREATION_FAILED',
} as const);

export type PracticeAttemptErrorCode = (typeof PRACTICE_ATTEMPT_ERROR_CODE)[keyof typeof PRACTICE_ATTEMPT_ERROR_CODE];

export type PracticeProposalTargetType = 'LESSONS' | 'KC';

export type PracticeProposalLesson = {
  id: string;
  title: string;
};

export type PracticeProposalAttempt = {
  answered: number | null;
  attemptId: string;
  errorCode: PracticeAttemptErrorCode | null;
  maxActivityNumber: number | null;
  sessionId: string | null;
  status: PracticeAttemptStatus;
};

export type PracticeProposal = {
  attempt: PracticeProposalAttempt | null;
  available: boolean;
  courseId: string;
  lessons: PracticeProposalLesson[];
  /** Assistant message of the turn that proposed it: the only message where its card belongs. */
  messageId: string;
  proposalId: string;
  targetType: PracticeProposalTargetType;
};

/** Where the launcher sends the student: the first playable activity or the session summary. */
export type PracticeAttemptTarget = { activityInstanceId: string } | { summary: true };

export type PracticeAttemptStart = {
  attemptId: string;
  errorCode: PracticeAttemptErrorCode | null;
  sessionId: string | null;
  status: PracticeAttemptStatus;
  target: PracticeAttemptTarget | null;
};
